import { Partner } from "@happy-legal/graphql-types";
import { createContext, ReactNode } from "react";
import { MUTATION_UPDATE_DISCOUNT } from "../gql/mutations";
import { TPartnerAction } from "../reducer";
import { partnerReducer } from "../reducer/partnerReducer";
import { createProvider, IObjectContextType } from "./ProviderFactory";

export const PartnerContext = createContext<
  IObjectContextType<Partner[], TPartnerAction>
>(undefined!);
// TODO: https://www.rivoltafilippo.com/typing-react-context-to-avoid-an-undefined-default-value

PartnerContext.displayName = "Partner Context";

export const partnerInitState = [];

const PartnerProvider = ({ children }: { children: ReactNode }) =>
  createProvider(
    PartnerContext,
    partnerReducer,
    partnerInitState,
    children,
    MUTATION_UPDATE_DISCOUNT
  );

export default PartnerProvider;
